import { ExternalLink, Star } from "lucide-react";

export const VibeCodingTools = () => {
  const tools = [
    {
      name: "Cursor",
      category: "IDE",
      description: "VS Code fork with deep AI integration. Best for developers who want AI in their existing workflow.",
      strengths: ["Tab completion", "Chat with codebase", "Multi-file edits"],
      pricing: "Free tier, $20/mo Pro",
      rating: 4.8,
    },
    {
      name: "Windsurf",
      category: "AI IDE",
      description: "AI-powered IDE with deep codebase understanding. Best for full-stack development with context awareness.",
      strengths: ["Codebase-wide context", "Multi-file edits", "Flow-based AI"],
      pricing: "Free tier, $15/mo Pro",
      rating: 4.7,
    },
    {
      name: "Claude",
      category: "AI Assistant",
      description: "Anthropic's AI with excellent coding abilities. Best for complex problem-solving and architecture.",
      strengths: ["Long context", "Nuanced understanding", "Code review"],
      pricing: "Free tier, $20/mo Pro",
      rating: 4.9,
    },
    {
      name: "GitHub Copilot",
      category: "Code Completion",
      description: "Industry standard for inline suggestions. Best for filling in code as you type.",
      strengths: ["IDE integration", "Context awareness", "Team plans"],
      pricing: "$10/mo individual, $19/mo business",
      rating: 4.6,
    },
    {
      name: "v0 by Vercel",
      category: "UI Builder",
      description: "Generate React components from descriptions. Best for frontend and UI work.",
      strengths: ["Tailwind + shadcn", "Iterative design", "Code export"],
      pricing: "Free tier, paid plans available",
      rating: 4.5,
    },
    {
      name: "Bolt.new",
      category: "Full-Stack Builder",
      description: "Build and deploy apps instantly. Best for quick experiments and demos.",
      strengths: ["Instant preview", "Multi-framework", "One-click deploy"],
      pricing: "Free tier available",
      rating: 4.4,
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        Top Vibe Coding Tools in 2025
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        These are the tools that are defining the vibe coding movement. Each has its strengths — 
        many developers use multiple tools together.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {tools.map((tool, index) => (
          <div
            key={index}
            className="bg-card rounded-xl border border-border p-6 hover:shadow-lg transition-shadow"
          >
            <div className="flex items-start justify-between mb-3">
              <div>
                <h3 className="text-lg font-semibold text-foreground">{tool.name}</h3>
                <span className="text-xs text-primary bg-primary/10 px-2 py-0.5 rounded-full">
                  {tool.category}
                </span>
              </div>
              <div className="flex items-center gap-1 text-chart-2">
                <Star className="w-4 h-4 fill-current" />
                <span className="text-sm font-medium">{tool.rating}</span>
              </div>
            </div>
            <p className="text-sm text-muted-foreground mb-4">{tool.description}</p>
            <div className="space-y-2 mb-4">
              {tool.strengths.map((strength, i) => (
                <div key={i} className="text-sm text-foreground flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary" />
                  {strength}
                </div>
              ))}
            </div>
            <div className="text-xs text-muted-foreground border-t border-border pt-3">
              {tool.pricing}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
